<template>
	<v-app>
		<Menu></Menu>

		<v-main>
			<v-container bg="green">
				<Header></Header>
				<router-view></router-view>
			</v-container >
		</v-main>
	</v-app>
</template>

<script>

import Menu from '@/components/Menu'
import Header from '@/components/Header'


export default {
	name: 'App',
	components: {
		Menu: Menu, 
		Header: Header,
	},
	data: () => ({
		//
	}),
};
</script>
